import React, { useState } from 'react';
import { Button } from '../shared/Button';
import { Card } from '../shared/Card';
interface WorkoutOverviewProps {
  navigateTo: (screen: string) => void;
  workoutData: any;
}
export const WorkoutOverview = ({
  navigateTo,
  workoutData
}: WorkoutOverviewProps) => {
  const [expandedSection, setExpandedSection] = useState(null);
  if (!workoutData) {
    return <div className="flex flex-col h-full p-6" data-id="element-1582">
        <div className="flex justify-between items-center mb-4" data-id="element-1583">
          <button onClick={() => navigateTo('home')} className="text-gray-500" data-id="element-1584">
            ← Back
          </button>
          <h1 className="text-xl font-bold text-gray-900" data-id="element-1585">Workout Overview</h1>
          <div className="w-6" data-id="element-1586"></div>
        </div>
        <div className="flex-1 flex items-center justify-center" data-id="element-1587">
          <p className="text-gray-500" data-id="element-1588">No workout data available</p>
        </div>
      </div>;
  }
  const toggleExpandSection = sectionId => {
    if (expandedSection === sectionId) {
      setExpandedSection(null);
    } else {
      setExpandedSection(sectionId);
    }
  };
  const startWorkout = () => {
    // In a real app, this would navigate to an active workout screen
    // For now, we'll just go back to the home screen
    navigateTo('home');
  };
  return <div className="flex flex-col h-full min-h-screen bg-white" data-id="element-1589">
      <div className="p-6 border-b border-gray-100" data-id="element-1590">
        <div className="flex justify-between items-center mb-4" data-id="element-1591">
          <button onClick={() => navigateTo('plan')} className="text-gray-500" data-id="element-1592">
            ← Back
          </button>
          <h1 className="text-xl font-bold text-gray-900" data-id="element-1593">Workout Overview</h1>
          <div className="w-6" data-id="element-1594"></div>
        </div>
        <div className="mt-2" data-id="element-1595">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1596">
            {workoutData.title}
          </h2>
          <div className="flex items-center text-gray-600 mb-4" data-id="element-1597">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-1598">
              <circle cx="12" cy="12" r="10" data-id="element-1599"></circle>
              <polyline points="12 6 12 12 16 14" data-id="element-1600"></polyline>
            </svg>
            <span data-id="element-1601">{workoutData.duration} minutes</span>
            {workoutData.location && <>
                <span className="mx-2" data-id="element-1602">•</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-1603">
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" data-id="element-1604"></path>
                  <circle cx="12" cy="10" r="3" data-id="element-1605"></circle>
                </svg>
                <span className="capitalize" data-id="element-1606">{workoutData.location}</span>
              </>}
            {workoutData.energy && <>
                <span className="mx-2" data-id="element-1607">•</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2" data-id="element-1608">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" data-id="element-1609"></path>
                </svg>
                <span className="capitalize" data-id="element-1610">
                  {workoutData.energy} intensity
                </span>
              </>}
          </div>
        </div>
        <Button onClick={startWorkout} variant="primary" fullWidth className="py-4 text-lg font-bold mb-4" data-id="element-1611">
          Start Workout
        </Button>
      </div>
      <div className="flex-1 p-6 overflow-y-auto" data-id="element-1612">
        <div className="mb-6" data-id="element-1613">
          <h3 className="font-bold text-gray-900 mb-3" data-id="element-1614">Workout Structure</h3>
          <div className="space-y-4" data-id="element-1615">
            {workoutData.exercises.map((section, index) => <Card key={index} className="overflow-hidden" data-id="element-1616">
                <div className="p-4 flex justify-between items-center cursor-pointer" onClick={() => toggleExpandSection(index)} data-id="element-1617">
                  <div className="flex items-center" data-id="element-1618">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center mr-3 ${section.type === 'warmup' ? 'bg-yellow-100 text-yellow-600' : section.type === 'cooldown' ? 'bg-blue-100 text-blue-600' : 'bg-green-100 text-green-600'}`} data-id="element-1619">
                      {section.type === 'warmup' ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1620">
                          <path d="M8 11.5a3.5 3.5 0 1 0 7 0 3.5 3.5 0 1 0-7 0" data-id="element-1621"></path>
                          <path d="M11.5 15v-7" data-id="element-1622"></path>
                        </svg> : section.type === 'cooldown' ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1623">
                          <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" data-id="element-1624"></path>
                        </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1625">
                          <path d="M18 8h1a4 4 0 0 1 0 8h-1" data-id="element-1626"></path>
                          <path d="M6 8h-1a4 4 0 0 0 0 8h1" data-id="element-1627"></path>
                          <path d="M8 8v8" data-id="element-1628"></path>
                          <path d="M16 8v8" data-id="element-1629"></path>
                          <path d="M12 8v8" data-id="element-1630"></path>
                        </svg>}
                    </div>
                    <div data-id="element-1631">
                      <h4 className="font-medium" data-id="element-1632">{section.name}</h4>
                      <p className="text-sm text-gray-500" data-id="element-1633">
                        {section.duration}
                      </p>
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`transition-transform ${expandedSection === index ? 'rotate-180' : ''}`} data-id="element-1634">
                    <path d="m6 9 6 6 6-6" data-id="element-1635"></path>
                  </svg>
                </div>
                {expandedSection === index && section.exercises && <div className="px-4 pb-4" data-id="element-1636">
                    <div className="pt-2 border-t border-gray-100" data-id="element-1637">
                      {section.exercises.map((exercise, exIndex) => <div key={exIndex} className="py-3 border-b border-gray-100 last:border-0" data-id="element-1638">
                          {exercise.exercises ?
                  // Nested exercise group (like circuit)
                  <div data-id="element-1639">
                              <div className="flex justify-between mb-2" data-id="element-1640">
                                <h5 className="font-medium" data-id="element-1641">{exercise.name}</h5>
                                <span className="text-sm text-gray-500" data-id="element-1642">
                                  {exercise.sets} sets
                                </span>
                              </div>
                              <div className="pl-4 space-y-2" data-id="element-1643">
                                {exercise.exercises.map((subEx, subIndex) => <div key={subIndex} className="flex justify-between items-center" data-id="element-1644">
                                    <span data-id="element-1645">{subEx.name}</span>
                                    <span className="text-sm text-gray-500" data-id="element-1646">
                                      {subEx.reps ? `${subEx.reps} reps` : `${subEx.duration}`}
                                    </span>
                                  </div>)}
                              </div>
                            </div> :
                  // Single exercise
                  <div className="flex justify-between items-center" data-id="element-1647">
                              <span data-id="element-1648">{exercise.name}</span>
                              <span className="text-sm text-gray-500" data-id="element-1649">
                                {exercise.sets ? `${exercise.sets} × ${exercise.reps || exercise.duration}` : exercise.duration || `${exercise.reps} reps`}
                              </span>
                            </div>}
                        </div>)}
                    </div>
                  </div>}
              </Card>)}
          </div>
        </div>
        <div className="mb-6" data-id="element-1650">
          <h3 className="font-bold text-gray-900 mb-3" data-id="element-1651">Equipment Needed</h3>
          <Card className="p-4" data-id="element-1652">
            <ul className="space-y-2" data-id="element-1653">
              <li className="flex items-center" data-id="element-1654">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 text-green-500" data-id="element-1655">
                  <path d="M20 6 9 17l-5-5" data-id="element-1656"></path>
                </svg>
                <span data-id="element-1657">Exercise mat</span>
              </li>
              {workoutData.location === 'gym' ? <>
                  <li className="flex items-center" data-id="element-1658">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 text-green-500" data-id="element-1659">
                      <path d="M20 6 9 17l-5-5" data-id="element-1660"></path>
                    </svg>
                    <span data-id="element-1661">Dumbbells (light to medium)</span>
                  </li>
                  <li className="flex items-center" data-id="element-1662">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 text-green-500" data-id="element-1663">
                      <path d="M20 6 9 17l-5-5" data-id="element-1664"></path>
                    </svg>
                    <span data-id="element-1665">Bench</span>
                  </li>
                </> : <li className="flex items-center" data-id="element-1666">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 text-green-500" data-id="element-1667">
                    <path d="M20 6 9 17l-5-5" data-id="element-1668"></path>
                  </svg>
                  <span data-id="element-1669">No additional equipment needed</span>
                </li>}
            </ul>
          </Card>
        </div>
        <div className="mb-6" data-id="element-1670">
          <h3 className="font-bold text-gray-900 mb-3" data-id="element-1671">Tips</h3>
          <Card className="p-4" data-id="element-1672">
            <ul className="space-y-2" data-id="element-1673">
              <li className="flex items-start" data-id="element-1674">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 mt-1 text-blue-500" data-id="element-1675">
                  <circle cx="12" cy="12" r="10" data-id="element-1676"></circle>
                  <path d="M12 16v-4" data-id="element-1677"></path>
                  <path d="M12 8h.01" data-id="element-1678"></path>
                </svg>
                <span data-id="element-1679">Stay hydrated throughout your workout</span>
              </li>
              <li className="flex items-start" data-id="element-1680">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 mt-1 text-blue-500" data-id="element-1681">
                  <circle cx="12" cy="12" r="10" data-id="element-1682"></circle>
                  <path d="M12 16v-4" data-id="element-1683"></path>
                  <path d="M12 8h.01" data-id="element-1684"></path>
                </svg>
                <span data-id="element-1685">Focus on proper form rather than speed</span>
              </li>
              <li className="flex items-start" data-id="element-1686">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 mt-1 text-blue-500" data-id="element-1687">
                  <circle cx="12" cy="12" r="10" data-id="element-1688"></circle>
                  <path d="M12 16v-4" data-id="element-1689"></path>
                  <path d="M12 8h.01" data-id="element-1690"></path>
                </svg>
                <span data-id="element-1691">Don't skip the warm-up and cool-down</span>
              </li>
            </ul>
          </Card>
        </div>
      </div>
      <div className="p-4 border-t border-gray-100" data-id="element-1692">
        <Button onClick={startWorkout} variant="primary" fullWidth data-id="element-1693">
          Start Workout
        </Button>
      </div>
    </div>;
};